import { configureStore } from '@reduxjs/toolkit';
import userReducer from './personalDetail'

export const store = configureStore({
  reducer: {
    user: userReducer
  },
})